module.exports = __webpack_public_path__ + "img/recorded_camera_button.a08c8ed2.svg";